export const QUALITY = 'quality';
export const QUALITY_ADD = 'quality_add';
export const QUALITY_DELETE = 'quality_deleted';
export const QUALITY_EDIT = 'quality_edit';

export const QUALITY_SETROWDATA = 'quality_set_rowdata';
export const MODEL_OPEN = 'quality_model_open';
export const MODEL_CLOSE = 'quality_model_close';
export const SET_PARAMS = 'quality_set_params';

export const QUALITY_LIST_SUCCESSFUL = 'quality_list_successfull';
export const QUALITY_ADD_SUCCESSFUL = 'quality_add_successfull';
export const QUALITY_EDIT_SUCCESSFUL = 'quality_edit_successfull';

export const API_ERROR = 'api_failed';
